import React from 'react';
import { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Skeleton } from 'antd';

import { FrameCollapse } from './FrameCollapse';
import { useOWASContext } from '../../../context';
import { TASKS_FILTER } from '../Filters/Analyzed';
import { useOwasEvaluationContext } from '../context';
import { PaginationCustom } from '@/components/Pagination';
import { useGetOwasFrames } from '../../../hooks/useGetOwasFrames';
import { useGetDownloadVideoURL } from '@/hooks/useGetVideoURL';

const INITIAL_PAGE = 1;
const FRAMES_PER_PAGE = 5;

export function Frames(): JSX.Element {
	const { parameters, data } = useOWASContext();
	const { filters } = useOwasEvaluationContext();
	const [page, setPage] = useState<number>(INITIAL_PAGE);
	const [isOpenCollapse, setIsOpenCollapse] = useState<string | undefined>(undefined);

	const payload = {
		organization_id: parameters.organization_id,
		company_id: parameters.company_id,
		file_id: parameters.file_id,
		report_id: data?.id ?? '',
		task_name: filters.name,
		limit: FRAMES_PER_PAGE,
		offset: page,
		not_analyzed: filters.type === TASKS_FILTER.NOT_ANALYZED
	};

	const { isLoading, data: frames, isError } = useGetOwasFrames(payload);

	const { data: video_url, refetch: refetchVideoUrl } = useGetDownloadVideoURL({
		organization_id: parameters.organization_id,
		company_id: parameters.company_id,
		file_id: parameters.file_id,
		original_name: data?.original_name ?? undefined
	});

	function handleOnChangePage(page: number): void {
		setPage(page);
	}

	function handleOnClickCollapse(key: string | undefined): void {
		setIsOpenCollapse(key);
	}

	if (isLoading) {
		return <Skeleton active />;
	}

	if (isError) {
		return <span>{I18n.get('Oops... Something went wrong!')}</span>;
	}

	return (
		<Row justify="end" gutter={[0, 20]}>
			<Col span={24}>
				<Row gutter={[0, 20]}>
					{frames.rows.map((frame) => (
						<FrameCollapse
							key={frame.id}
							frame={frame}
							video_url={video_url}
							onClick={handleOnClickCollapse}
							activeCollapse={isOpenCollapse}
							onVideoError={refetchVideoUrl}
						/>
					))}
				</Row>
			</Col>
			<Col span={24}>
				<PaginationCustom
					total={frames.total}
					defaultCurrent={page}
					showSizeChanger={false}
					pageSize={FRAMES_PER_PAGE}
					onChange={handleOnChangePage}
					onRowsPerPageChange={() => null}
				/>
			</Col>
		</Row>
	);
}
